// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Room } from './Room';
import {
    RoomFromJSON,
    RoomFromJSONTyped,
    RoomToJSON,
    RoomToJSONTyped,
} from './Room';

/**
 * 
 * @export
 * @interface RoomResponse
 */
export interface RoomResponse {
    /**
     * 
     */
    data?: Room;
}

/**
 * Check if a given object implements the RoomResponse interface.
 */
export function instanceOfRoomResponse(value: object): value is RoomResponse {
    return true;
}

export function RoomResponseFromJSON(json: any): RoomResponse {
    return RoomResponseFromJSONTyped(json, false);
}

export function RoomResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : RoomFromJSON(json['data']),
    };
}

export function RoomResponseToJSON(json: any): RoomResponse {
    return RoomResponseToJSONTyped(json, false);
}

export function RoomResponseToJSONTyped(value?: RoomResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': RoomToJSON(value['data']),
    };
}

